import React, { Component } from 'react'
import Slider from 'react-slick'
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
var arrowStyle = {
  display: 'block',
  zIndex: 1000
}
function NextArrow(props) {
  const { className, style, onClick } = props
  return (
    <div
      className={className}
      style={{ ...style, ...arrowStyle, right: 0 }}
      onClick={onClick}
    ></div>
  );
}

function PrevArrow(props) {
  const { className, style, onClick } = props
  return (
    <div
      className={className}
      style={{ ...style, ...arrowStyle, left: 0 }}
      onClick={onClick}
    ></div>
  );
}


export default class ImageSlider extends Component {
  render() {
    const settings = {
      infinite: true,
      speed: 700,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />
    }
    return (
      <Slider {...settings}>
        {this.props.items.map(item => item)}
      </Slider>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/imageSlider/index.js